import { createEventsCacheLockId } from 'owa-events-cache';
import { getLockedCalendarEventsStore } from './getLockedCalendarEventsStore';
import { LockedCalendarEventsStore } from '../../types/LockedCalendarEventsStore';

export function createLockedCalendarEventsStore(): LockedCalendarEventsStore {
    const lockId = createEventsCacheLockId();

    return getLockedCalendarEventsStore(lockId);
}
